import './PitcherSessionPitchTypeRangesChart.scss';

import { PitchTypeRangesChartConfigDto, PitchTypeRangesChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/Pitcher/reportStore';
import PitchTypeRangesChart from 'components/Charts/PitchTypeRangesChart/PitchTypeRangesChart';

const PitcherSessionPitchTypeRangesChart = (props: ChartProps<PitchTypeRangesChartDataDto, PitchTypeRangesChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PitcherSessionPitchTypeRangesChart-container'>
      <PitchTypeRangesChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />
    </div>
  );
};

export default PitcherSessionPitchTypeRangesChart;
